import { FC } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import {
  CustomerSettingsPageTitle,
  CustomerSettingsPageSubtitle,
} from '../CustomersSettingsPage.styled';
import { useAuthRouteDataContext } from 'providers/AuthRouteDataProvider/AuthRouteDataProvider.context';
import { useParams } from 'react-router-dom';
import { Flex } from 'components/Flex';

interface CustomersSettingsPageHeaderProps {
  title?: string;
}

export const CustomersSettingsPageHeader: FC<CustomersSettingsPageHeaderProps> = ({ title }) => {
  const { t } = useTranslation();
  const {
    locationFilter: { data },
  } = useAuthRouteDataContext();
  const { locationId } = useParams<{ locationId: string }>();
  const selectedSettingsLocation = data.find((loc) => loc.id === locationId);

  return (
    <Flex gap="24px" flexDirection="column">
      <CustomerSettingsPageTitle>
        {title || t('location_settings:CUSTOMERS')}
      </CustomerSettingsPageTitle>
      <CustomerSettingsPageSubtitle>
        {selectedSettingsLocation?.label || ''}
      </CustomerSettingsPageSubtitle>
    </Flex>
  );
};
